import styled from "styled-components";

export const GridWrapper = styled.div`
    height: 62vh;
    width: 100%;

    @media (max-height: 1080px) {
        height: 51vh;
    }

    .ag-header-cell {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .ag-header-cell > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
    }

    .ag-header-cell > .ag-react-container {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .ag-header-cell > .ag-react-container > div {
        text-align: center;
    }

    .ag-cell {
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .ag-header-row {
        background-color: lightgray;
    }
`;

export const MobileWrapper = styled.div`
    .form-group {
        margin-bottom: 15px;
    }
`;